export default "__VITE_ASSET__bQ8nujrC__"